import React from 'react'
import SideNav from 'steps/landing/SideNav'
import { NavBar } from 'components/NavBar/NavBar'

export const BreakNavigation = ({
  navigationType,
  stepStatusArr,
  activeStepPosition,
  onItemClicked,
  brk,
  inline = false,
}) => {
  const stepStatusStr = JSON.stringify(stepStatusArr)

  if (navigationType === 'LEFT') {
    return (
      <SideNav
        stepStatusStr={stepStatusStr}
        onItemClicked={onItemClicked}
        brk={brk}
        activeStepPosition={activeStepPosition}
      />
    )
  }

  if (navigationType === 'TOP') {
    return (
      <NavBar
        stepStatusStr={stepStatusStr}
        onItemClicked={onItemClicked}
        brk={brk}
        activeStepPosition={activeStepPosition}
        inline={inline}
      />
    )
  }

  return null
}
